import React, { FunctionComponent, useState, useEffect } from "react";
import Inputs, {
  InputsGroup,
  InputLabel,
  InputImage,
} from "../../Components/Inputs";

type FormTipoOperacionProps = {
  item: any;
  action: string;
  errors: any;
  handleOnChange: (e: any) => void;
  options: any;
};

const FormTipoOperacion: FunctionComponent<FormTipoOperacionProps> = ({
  item,
  action,
  errors,
  handleOnChange,
  options,
}) => {
  const [status, setStatus] = useState([]);

  useEffect(() => {
    handleStatus();
  }, []);

  const handleStatus = () => {
    const statusList: any = [
      { value: 1, text: "Activo" },
      { value: 0, text: "Inactivo" },
    ];
    setStatus(statusList);
  };

  const renderInputs = () => {
    if (action === "view") {
      return (
        <>
          <InputsGroup>
            <InputLabel label={"Marca"} value={item?.marca} />
          </InputsGroup>
          <InputsGroup>
            <InputLabel
              label={"Tipo de Operación SC"}
              value={item?.tipoOperacion}
            />
          </InputsGroup>
          <InputsGroup>
            <InputLabel label={"Alias"} value={item?.tipoOperacion} />
          </InputsGroup>
          <InputsGroup>
            <InputLabel label={"Código"} value={item?.codigoTipoOperacion} />
          </InputsGroup>
          <InputsGroup>
            <InputImage
              label={"Imagen"}
              id={item?.logo}
              value={item?.signPath}
            />
          </InputsGroup>
          <InputsGroup>
            <InputLabel label={"Estatus"} value={item?.estatus} />
          </InputsGroup>
        </>
      );
    } else {
      return (
        <>
          <InputsGroup>
            <>
              <Inputs
                id={"idMarca"}
                label={"Marca"}
                type={"select"}
                value={item?.idMarca}
                handleOnChange={handleOnChange}
                options={options.brands}
                className={`input ${errors["idMarca"] ? "input_error" : ""}`}
                errorMessage={errors["idMarca"]}
                disable={item.idTipoOperacion ? true : false}
              />
              <Inputs
                id={"idTipoOperSc"}
                label={"Tipos de Operación SC"}
                type={"select"}
                value={item?.idTipoOperSc}
                handleOnChange={handleOnChange}
                options={options.operaciones}
                className={`input ${
                  errors["idTipoOperSc"] ? "input_error" : ""
                }`}
                errorMessage={errors["idTipoOperSc"]}
                disable={item.idTipoOperacion ? true : false}
              />
            </>
          </InputsGroup>
          <InputsGroup>
            <>
              <Inputs
                id={"tipoOperacion"}
                label={"Alias"}
                type={"text"}
                value={item?.tipoOperacion}
                handleOnChange={handleOnChange}
                className={`input ${
                  errors["tipoOperacion"] ? "input_error" : ""
                }`}
                errorMessage={errors["tipoOperacion"]}
                maxLength={50}
                disable={item.idTipoOperacion ? true : false}
              />
              <Inputs
                id={"codigoTipoOperacion"}
                label={"Código"}
                type={"text"}
                value={item?.codigoTipoOperacion}
                handleOnChange={handleOnChange}
                className={`input ${
                  errors["codigoTipoOperacion"] ? "input_error" : ""
                }`}
                errorMessage={errors["codigoTipoOperacion"]}
                maxLength={10}
                disable={item.idTipoOperacion ? true : false}
              />
            </>
          </InputsGroup>
          <InputsGroup>
            <>
              <Inputs
                id={"logo"}
                label={"Imagen"}
                type={"file"}
                value={item?.logo}
                accept={".jpeg,.jpg,.png"}
                labelPercent={25}
                handleOnChange={handleOnChange}
                className={`input ${errors["imagen"] ? "input_error" : ""}`}
                errorMessage={errors["imagen"]}
              />
              <Inputs
                id={"idEstatus"}
                label={"Estatus"}
                type={"select"}
                value={item?.idEstatus}
                visible={!(action === "edit")}
                handleOnChange={handleOnChange}
                options={status}
                className={`input ${errors["idEstatus"] ? "input_error" : ""}`}
                errorMessage={errors["idEstatus"]}
              />
            </>
          </InputsGroup>
        </>
      );
    }
  };

  return <>{renderInputs()}</>;
};

export default FormTipoOperacion;
